import { bootstrapApplication } from '@angular/platform-browser';
import { PreloadAllModules, RouteReuseStrategy, provideRouter, withDebugTracing, withPreloading } from '@angular/router';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';
import { provideHttpClient, withInterceptors } from '@angular/common/http';

import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';
import { provideServiceWorker } from '@angular/service-worker';
import { environment } from './environments/environment';
import { authInterceptor } from './app/interceptors/auth.interceptor';
import { installGtagConsentDefaults } from './app/consent/gtag-defaults';
import { ConsentService } from './app/consent/consent.service';
import { initializeClarityWithConsent } from './app/telemetry/clarity-consent-bootstrap';
import { initializeGoogleAnalyticsWithConsent } from './app/telemetry/ga-consent-bootstrap';
import { initializeFeedbackWidgetWithConsent } from './app/telemetry/feedback-widget-consent-bootstrap';
import { initializeUsersnapWithConsent } from './app/telemetry/usersnap-consent-bootstrap';

installGtagConsentDefaults(environment.gaMeasurementId);

bootstrapApplication(AppComponent, {
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular(),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideRouter(
      routes,
      withPreloading(PreloadAllModules),
      ...(environment.debugRouterTracing ? [withDebugTracing()] : []),
    ),
    provideServiceWorker('ngsw-worker.js', {
      // `ng serve` does not emit ngsw-worker.js; only production builds do.
      enabled: environment.production && environment.pwaEnabled,
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
}).then(async (applicationRef) => {
  const consent = applicationRef.injector.get(ConsentService);
  await consent.whenReady;

  initializeUsersnapWithConsent(consent, environment.usersnapGlobalLoadId);

  if (environment.feedbackWidgetEnabled) {
    initializeFeedbackWidgetWithConsent(applicationRef, consent, environment.apiBaseUrl);
  }

  if (environment.clarityProjectId) {
    initializeClarityWithConsent(applicationRef, environment.clarityProjectId);
  }

  if (environment.production && environment.gaMeasurementId) {
    initializeGoogleAnalyticsWithConsent(applicationRef, environment.gaMeasurementId);
  }
});
